import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import api from '../../axiosConfig'

const UpgradeYourPlan = () => {

  const [usuarios, setUsuarios] = useState(0);
  const [autorizaciones, setAutorizaciones] = useState(0);
  const [notificaciones, setNotificaciones] = useState(0);
  const [notificacionesVistas, setNotificacionesVistas] = useState(0);


  useEffect(() => {

    fetchNotificaciones();

  }, []);


  const fetchNotificaciones = async () => {
    try {
      const res = await api.get(`/dashboard/admin/cards`);
      if (res.status === 200) {
        setUsuarios(res.data.usuarios)
        setNotificaciones(res.data.notificaciones)
        setNotificacionesVistas(res.data.notificacionesVistas)
        setAutorizaciones(res.data.autorizaciones)
      }
    } catch (e) {
      //setErr("No se pudieron cargar las notificaciones.");
    } finally {
    }
  };


  return (
    <div className='col-xxl-12'>
      <div className='card'>
        <div className='card-body p-20'>
          <div className='row g-3'> 
            <div className='col-md-12'>
              <div className='row g-3'>
                <div className='col-sm-3 col-xs-3'>
                  <div className='radius-8 h-100 text-center p-20 bg-purple-light'>
                    <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-lilac-200 border border-lilac-400 text-lilac-600'>
                      <i className='ri-price-tag-3-fill' />
                    </span>
                    <span className='text-neutral-700 d-block'>
                      Usuarios
                    </span>
                    <h6 className='mb-0 mt-4'>{usuarios}</h6>
                  </div>
                </div>
                <div className='col-sm-3 col-xs-3'>
                  <div className='radius-8 h-100 text-center p-20 bg-success-100'>
                    <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-success-200 border border-success-400 text-success-600'>
                      <i className='ri-shopping-cart-2-fill' />
                    </span>
                    <span className='text-neutral-700 d-block'>
                      Notificaciones
                    </span>
                    <h6 className='mb-0 mt-4'>{notificaciones}</h6>
                  </div>
                </div>
                <div className='col-sm-3 col-xs-3'>
                  <div className='radius-8 h-100 text-center p-20 bg-info-focus'>
                    <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-info-200 border border-info-400 text-info-600'>
                      <i className='ri-group-3-fill' />
                    </span>
                    <span className='text-neutral-700 d-block'>Notificaciones vistas</span>
                    <h6 className='mb-0 mt-4'>{notificacionesVistas}</h6>
                  </div>
                </div>
                <div className='col-sm-3 col-xs-3'>
                  <div className='radius-8 h-100 text-center p-20 bg-danger-100'>
                    <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-danger-200 border border-danger-400 text-danger-600'>
                      <i className='ri-refund-2-line' />
                    </span>
                    <span className='text-neutral-700 d-block'>Autorizaciones</span>
                    <h6 className='mb-0 mt-4'>{autorizaciones}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeYourPlan;
